import { useApi } from '../services';

export const useGetClausesByProduct = (idOperation) => useApi(
    `/v2/operation/${idOperation}/get-clauses`,
    'POST',
    {},
    {}
);

export const useGetClausesByDocument = (idOperation) => useApi(
    `/v2/operation/${idOperation}/clauses/document`,
    'GET',
    {},
    {}
);

export const useUpdateDocumentsClausesSync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/clauses`,
    'POST',
    {},
    {},
    true
);